// extracted by mini-css-extract-plugin
module.exports = {"section":"style-module--section--20Lp_","sectionInner":"style-module--sectionInner--21zpU","title":"style-module--title--jBqKm","description":"style-module--description--O8XJe"};